import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react'
import pako from 'pako'

import { FeatureType } from 'clickNgo/configs/feature'
import { getAccessToken } from 'cng-common/helpers/access'
import settings from 'src/config/settings'

import type { IGetPlanningParams, IPlanningGzipResponse } from '../model'

export const planningApi = createApi({
  reducerPath: `${FeatureType.P360Api}/planningApi`,
  baseQuery: fakeBaseQuery(),
  endpoints: (build) => ({
    getPlanning: build.query<IPlanningGzipResponse['data'], IGetPlanningParams>({
      queryFn: async (params, { signal }) => {
        try {
          const url = `${settings.httpsServices.partner360}/api/v0/partnerData/planningGzip`
          const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json; charset=UTF-8',
              Authorization: `Bearer ${getAccessToken()}`,
            },
            body: JSON.stringify({
              partnerId: params.partnerId,
              fYear: params.fYear,
              fYearFrom: params.fromFYear,
              programType: params.programType,
              isRegionalDistributor: params.isRegionalDistributor ? 1 : undefined,
            }),
            signal,
          })

          if (!response.ok) {
            return { error: { status: response.status, data: response.statusText } }
          }

          const gzipData = await response.arrayBuffer()
          const unpackedData = pako.ungzip(gzipData, { to: 'string' })
          const parsedData = JSON.parse(unpackedData) as IPlanningGzipResponse

          return { data: parsedData.data }
        } catch (error) {
          return { error: { status: 'CUSTOM_ERROR', data: String(error) } }
        }
      },
    }),
  }),
})

export const { useGetPlanningQuery, useLazyGetPlanningQuery } = planningApi
